import { render, staticRenderFns } from "./TestPassV2.vue?vue&type=template&id=2e69ccef&"
import script from "./TestPassV2.vue?vue&type=script&lang=ts&"
export * from "./TestPassV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports